import { Text } from '@savvy-kit/foundations/text';

export default function ItemHeader({ text }: { readonly text: string }) {
  return (
    <div className="mb-6">
      <Text variant="h4">{text}</Text>
    </div>
  );
}
